import { render, staticRenderFns } from "./FinanceArea.vue?vue&type=template&id=25faa6fc&scoped=true&"
import script from "./FinanceArea.vue?vue&type=script&lang=js&"
export * from "./FinanceArea.vue?vue&type=script&lang=js&"
import style0 from "./FinanceArea.vue?vue&type=style&index=0&id=25faa6fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25faa6fc",
  null
  
)

export default component.exports